"use client"

import { Box, Modal } from "@mui/material" // Import Material UI Modal
import type { StaticImport } from "next/dist/shared/lib/get-img-props"
import Image from "next/image"
import type React from "react"
import { type CSSProperties, useState } from "react"

type ZoomableImageProps =
  | {
      src: StaticImport
      alt: string
      style?: CSSProperties // Accept style as a prop
      width?: number
      height?: number
    }
  | {
      src: string
      alt: string
      width: number
      height: number
      style?: CSSProperties // Accept style as a prop
    }

const ZoomableImage: React.FC<ZoomableImageProps> = ({
  src,
  alt,
  width,
  height,
  // width = "300px",
  // height = "auto",
  style = {}, // Default to empty object
}) => {
  const [isZoomed, setIsZoomed] = useState(false) // Control zoom state

  const handleZoomToggle = () => {
    setIsZoomed(!isZoomed) // Toggle zoom state
  }

  return (
    <>
      {/* Normal Image */}
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        onClick={handleZoomToggle} // Open modal on click
        style={{
          cursor: "pointer",
          transition: "transform 0.3s",
          ...style,
        }}
      />

      {/* Modal for Zoomed Image */}
      <Modal
        open={isZoomed} // Modal opens when isZoomed is true
        onClose={handleZoomToggle} // Close modal when clicked
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          onClick={handleZoomToggle} // Clicking on the image or box closes it
          sx={{
            outline: "none", // Remove outline when clicked
          }}
        >
          <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "90vw", // Limit size to viewport width
              maxHeight: "90vh", // Limit size to viewport height
              borderRadius: "12px",
              boxShadow: "0px 4px 6px #262f4255",
              cursor: "pointer",
            }}
          />
        </Box>
      </Modal>
    </>
  )
}

export default ZoomableImage
